module.exports = __webpack_public_path__ + "static/img/prizeo-favicon.952b53e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icons/prizeo-favicon.png
// module id = 2527
// module chunks = 0